/*!
 * Copyright Optimus Ride 2019
 */

import { OperatingAreaDetails } from '../../grpc/site_pb';
import { Coordinates, toCoordinates } from './common';

export interface OperatingArea {
    abbrName?: string;
    email?: string;
    id: number;
    name: string;
    timezone: string;
    disabled: boolean;
    latLonCenter?: Coordinates;
}

export function toOperatingAreaDetails(opAreaDetails: OperatingAreaDetails): OperatingArea {
    return {
        email: opAreaDetails.getEmail(),
        id: opAreaDetails.getOperatingAreaId(),
        name: opAreaDetails.getName(),
        timezone: opAreaDetails.getTimeZone(),
        disabled: opAreaDetails.getDisabled(),
        latLonCenter: toCoordinates(opAreaDetails.getLatLonCenter()),
    }
}

export function isOperatingArea(thingToCheck:any):thingToCheck is OperatingArea {
    return (
        (thingToCheck as OperatingArea).id !== undefined && 
        (thingToCheck as OperatingArea).name !== undefined
    )
}
